import { StylesConfig } from "react-select";

export const selectStyles: StylesConfig = {
  control: (styles, { isFocused }) => ({
    ...styles,
    height: "100%",
    boxShadow: isFocused ? "none" : styles.boxShadow,
    borderColor: isFocused ? "transparent" : styles.borderColor,
    "&:hover": { borderColor: "transparent" },
  }),
  placeholder: (styles) => ({
    ...styles,
    color: "rgba(17, 32, 77, 0.7)",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#11204d",
  }),
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      color: isSelected ? "#11204d" : "#11204d",
    };
  },
  indicatorsContainer: (styles) => ({
    ...styles,
    color: "#11204d",
  }),
};
